"use client";

import { useVariant } from "./VariantProvider.js";
import { resolveImageUrl } from "../commerce/images.js";

export function VariantGallery() {
  const { images, product } = useVariant();

  return (
    <div className="grid grid-cols-2 gap-2">
      {images.slice(0, 4).map((img: any, i: number) => (
        <div key={img.link} className="aspect-3/4 overflow-hidden rounded bg-slate-100">
          <img
            src={resolveImageUrl(img.link)}
            alt={img.alt ?? product.name ?? ""}
            className="h-full w-full object-cover"
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}
    </div>
  );
}
